export default __webpack_public_path__ + "static/media/CUB.2190b143.svg";